<div class="flex flex-col justify-center h-9 px-3 py-2">
  @if (!this.isHovered) {
    <span class="w-full h-[1px] bg-border-subdued"></span>
  } @else {
    <p
      class="text-xs font-bold text-content-subdued line-clamp-1 relative text-left"
    >
      {{ this.title | translate }}
    </p>
  }
</div>
